import { Button, Modal } from 'react-bootstrap';
import React, { useState } from 'react';
import { toast } from 'react-toastify';
import { IInvoice } from 'src/types/invoice';
import classNames from 'classnames';
import styles from '../assets/invoice-grid.module.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope } from '@fortawesome/free-solid-svg-icons';
import { sendToDocusign } from '../../../../../../../store/actions/invoice-actions';
import { useDispatch } from 'react-redux';
import user from '../../../../../../../services/user-auth';
import UserRole from '../../../../../../../enumerables/user-role';

interface Props {
    original: IInvoice;
    filters: any;
    persistInvoice: (params: any, arr: any, res: any) => void;
}

const SendToDocusignInvoice: React.FunctionComponent<Props> = ({ original, filters, persistInvoice }: Props) => {
    const [openedDocusign, setOpenedDocusign] = useState(false);
    const [invoiceSentDocusign, setInvoiceSentDocusign] = useState(0);
    const handleClose = () => {
        setOpenedDocusign(false);
    };

    const dispatch = useDispatch();

    const sendInvoiceToDocusign = (id: string | number, statusDocusign: number) => {
        dispatch(
            sendToDocusign(
                { id: id, statusDocusign: statusDocusign, filters: filters },
                {
                    resolve: () => {
                        toast.success('Invoice was sent to DocuSign');
                        setInvoiceSentDocusign(statusDocusign);
                    },
                    reject: (errorMessage: string) => {
                        toast.error(errorMessage);
                    },
                },
            ),
        );
        handleClose();
    };

    const isAdmin = user.getRoles().includes(UserRole.ROLE_ADMIN);

    if (original.statusDocusign === 4) {
        return <div className={classNames(styles.signed)}> Signed</div>;
    }
    if (original.statusDocusign === 2 || invoiceSentDocusign === 2) {
        return <div className={classNames(styles.sent)}> Sent</div>;
    }
    if (original.statusDocusign === 3 || invoiceSentDocusign === 3) {
        return <div className={classNames(styles.notSent)}> Not sent</div>;
    }
    if (original.statusDocusign === 1 && !invoiceSentDocusign && isAdmin) {
        return (
            <div className={classNames(styles.button)}>
                <button className={'btn btn-outline-info'} onClick={() => setOpenedDocusign(true)}>
                    <FontAwesomeIcon icon={faEnvelope} /> Send
                </button>
                <Modal show={openedDocusign} onHide={handleClose}>
                    <Modal.Header closeButton>
                        <Modal.Title>Confirmation</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        Are you sure you want to send this invoice documents to be signed via DocuSign? If you decline,
                        then this invoice documents won't be signed with DocuSign anymore
                    </Modal.Body>
                    <Modal.Footer>
                        <Button
                            variant="secondary"
                            onClick={() => sendInvoiceToDocusign(original?.id ? original?.id : 0, 3)}
                        >
                            No
                        </Button>
                        <Button
                            variant="success"
                            onClick={() => sendInvoiceToDocusign(original?.id ? original?.id : 0, 2)}
                        >
                            Yes
                        </Button>
                    </Modal.Footer>
                </Modal>
            </div>
        );
    }

    return <div></div>;
};

export default SendToDocusignInvoice;
